import React from "react";

import companyLogoText from '../img/logoText.png';
import { Spin } from 'antd'


const SurveyLoadingScreen = () => {

    return (
        <React.Fragment>
            <Spin spinning={true} size="large" className="loadingSurvey"></Spin>
        </React.Fragment>
    );
};
export default SurveyLoadingScreen;


//<img src={companyLogoText} className="textLogo blink_me" />
//    <span className="please-wait blink_me">Please wait while we prepare your survey</span>